import { useMemo } from 'react'
import { IControlColors, IControlSimpleColors, useControlColors } from './useControlColors'

export type ControlKind = 'alarm' | 'state' | 'generic'

export interface ResolvedControlTheme {
  bg: string
  text: string
  textBg: string
  border: string
  palette?: IControlColors
  genericColors: IControlSimpleColors
}

export const useControlTheme = () => {
  const { alarmControlColors, stateControlColors, genericControlColors } = useControlColors()

  const resolve = (kind: ControlKind, state: string): ResolvedControlTheme => {
    const palette = kind === 'alarm' ? alarmControlColors : stateControlColors

    if (kind === 'generic') {
      return {
        bg: genericControlColors.bgColor,
        text: genericControlColors.textColor,
        textBg: genericControlColors.textBgColor,
        border: genericControlColors.borderColor,
        genericColors: genericControlColors,
        palette: palette
      }
    }

    switch (state) {
      case 'on':
        return {
          bg: palette.onBgColor,
          text: palette.onTextColor,
          textBg: palette.onTextBgColor,
          border: palette.onBorderColor,
          palette,
          genericColors: genericControlColors
        }

      case 'off':
        return {
          bg: palette.offBgColor,
          text: palette.offTextColor,
          textBg: palette.offTextBgColor,
          border: palette.offBorderColor,
          palette,
          genericColors: genericControlColors
        }

      default:
        return {
          bg: palette.unknownBgColor,
          text: palette.unknownTextColor,
          textBg: palette.unknownTextBgColor,
          border: palette.unknownBorderColor,
          palette,
          genericColors: genericControlColors
        }
    }
  }

  return useMemo(() => ({ resolve }), [alarmControlColors, stateControlColors, genericControlColors])
}
